export default "__VITE_ASSET__CdiFztkK__"